import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { intlShape } from 'react-intl'
import { Helmet } from 'react-helmet'
import classNames from 'classnames'

import { getFocus as getFocusAction } from './focusActions'
import Loader from '../../components/loader/Loader'
import { clearPlayqueue as clearPlayqueueAction } from '../../components/miniPlayer/AudioPlayer/playerActions'
import * as selectors from './focusSelectors'
import * as shapes from '../../constant/shapes'
import appConst from '../../constant/appConst'
import FocusAlbumCard from './FocusAlbumCard'
import * as playerSelectors from '../../components/miniPlayer/miniPlayerSelectors'
import * as constant from '../../components/miniPlayer/AudioPlayer/playerConstants'
import FocusAlbumBloc from './FocusAlbumBloc'
import ShareComponent from '../../components/share/ShareComponent'
import ReadMoreComponent from "../../components/ReadMoreComponent"
import GTMController from "../../utils/kpi/GTMController"

class FocusPage extends PureComponent {

	constructor(props) {
		super(props)
		this.state = {
			defaultCardHeight: null,
			defaultImageHeight: null
		}
		this.setCardsSizes = this.setCardsSizes.bind(this)
		this.onResize = this.onResize.bind(this)
	}

	componentWillMount() {
		const { id, getFocus } = this.props
		getFocus(id)
	}

	componentDidMount() {
		this.setCardsSizes()
		window.addEventListener('resize', this.onResize, false)
	}

	componentWillUnmount() {
		this.props.clearPlayqueue()
		window.removeEventListener('resize', this.onResize, false)
	}

	componentWillReceiveProps(nextProps) {
		const { id } = this.props
		if (id !== nextProps.id) {
			this.props.clearPlayqueue()
		}
		if (nextProps.titleContainer.title) {
			GTMController.pushFocusPageEvent(nextProps.titleContainer.author, nextProps.titleContainer.title)
		}
	}

	onResize() {
		this.setCardsSizes()
	}

	setCardsSizes() {
		const metaHeight = 54
		const albums = document.querySelectorAll('.albums-generic-grid-list > .item')
		if (albums) {
			const firstAlbum = albums[0]
			if (firstAlbum) {
				const cardWith = +firstAlbum.clientWidth
				this.setState({
					defaultImageHeight: cardWith - 2, // 1px border
					defaultCardHeight: cardWith + metaHeight
				})
			}
		}
	}

	render() {

		const { titleContainer, imageContainer, content, isCurrentTrack, isPlaying, id } = this.props
		const { intl } = this.context

		let shouldDisplayLettrine = true

		const shouldFadeOut = content && content.length && content[content.length - 1].type === appConst.focus.layout.text

		return (
			<Loader>
				<div className="page page--focus">
					<Helmet>
						<title>{intl.formatMessage({ id: 'title.focus' })}</title>
					</Helmet>

					<div className="focus">

						<div className="focus__heading">

							<div className="focus__background">
								{imageContainer &&
								<img className="focus__cover" src={imageContainer.image} alt={imageContainer.credits} />}
								<div className="focus__gradient" />
							</div>
							<div className="focus__meta">
								<h1 className="focus__title">{titleContainer.title}</h1>
								<p
									className="focus__author">{intl.formatMessage({ id: 'focus.from' }, { author: titleContainer.author })}</p>
								{titleContainer.date &&
								<p className="focus__date">
									{intl.formatDate(titleContainer.date, {
										day: 'numeric',
										month: 'long',
										year: 'numeric'
									})}
								</p>
								}
							</div>
							<ShareComponent
								GTMCopyEvent={GTMController.EVENTS.FOCUS_SHARE}
								className="focus__button pct pct-share"
							/>
							<ShareComponent
								GTMCopyEvent={GTMController.EVENTS.FOCUS_SHARE}
								className="focus__button focus__button--header pct pct-share"
							/>

						</div>

						{titleContainer.accroche &&
						<p className="focus__intro" dangerouslySetInnerHTML={{ __html: `${titleContainer.accroche}`.nl2br() }} />}

						{content.map((container, key) => {
							switch (container.type) {
								case appConst.focus.layout.text:
									const classes = classNames('focus__content focus__content--text', {
										lettrine: shouldDisplayLettrine
									})
									shouldDisplayLettrine = false
									return (
										<p key={`focus-container-${key}`} className={classes}>
											<span
												dangerouslySetInnerHTML={{ __html: `${container.description}`.nl2br() }}
												className="focus__text"
											/>
										</p>
									)
								case appConst.focus.layout.carousel:
									let albumList = []
									if (container.albums && container.albums.items && container.albums.items.length) {
										albumList = container.albums.items.slice(0, container.number_col * container.number_raw)
									}
									return (
										<section key={`focus-container-${key}`} className="carousel">
											<div className="carousel__titles">
												<p className="carousel__title">{container.title} {container.focus}</p>
												{container.sub_title &&
												<p className="carousel__subtitle">{container.sub_title}</p>
												}
											</div>
											<div className={`carousel__cards col-${container.number_col}`}>
												{albumList.map((album, index) => <FocusAlbumCard
													forceCardHeight={this.state.defaultCardHeight}
													forceImageHeight={this.state.defaultImageHeight}
													key={`album-${index}`}
													GTMPlayEvent={GTMController.EVENTS.FOCUS_PLAY}
													current={isCurrentTrack(constant.ORIGIN_PLAYQUEUE_TYPES.album, album.id)}
													playing={isPlaying}
													album={album}
												/>)}
											</div>
											<p className="carousel__text">{intl.formatMessage({ id: 'focus.joinQobuz' })}</p>
											<ReadMoreComponent id={id} type="focus" className="carousel__button"/>
										</section>
									)
								case appConst.focus.layout.image:
									return (
										<section key={`focus-container-${key}`} className="focus__content">
											<div className="image-content">
												<img src={container.image} alt={container.credits} />
												<p className="text-center t3 c3">{container.credits}</p>
											</div>
										</section>
									)
								case appConst.focus.layout.quote:
									return (
										<section key={`focus-container-${key}`} className="focus__content">
											<div className="quote-content">
												<p>{container.content}</p>
												<p className="quote-author">{container.title}</p>
											</div>
										</section>
									)
								case appConst.focus.layout.doubleImages:
									return (
										<ul key={`focus-container-${key}`} className="focus__content">
											<li><img src={container.left_img} alt="" /></li>
											<li><img src={container.right_img} alt="" /></li>
										</ul>
									)
								case appConst.focus.layout.album:
									return (
										<section key={`focus-container-${key}`} className="focus__album">
											<FocusAlbumBloc
												album={container.album}
												current={isCurrentTrack(constant.ORIGIN_PLAYQUEUE_TYPES.album, container.album.id)}
												playing={isPlaying}
											/>
											<p className="carousel__text">{intl.formatMessage({ id: 'focus.joinQobuz' })}</p>
											<ReadMoreComponent id={id} type="focus" className="carousel__button" />
										</section>
									)
								case appConst.focus.layout.playlist:
								default:
									return null
							}
						})}
					</div>
				</div>
			</Loader>
		)
	}

}

FocusPage.propTypes = {
	id: PropTypes.string,
	content: PropTypes.arrayOf(shapes.focusContent),
	titleContainer: shapes.focusTitle,
	imageContainer: shapes.focusImage,
	isCurrentTrack: PropTypes.func,
	isPlaying: PropTypes.bool,
	getFocus: PropTypes.func,
	clearPlayqueue: PropTypes.func
}

FocusPage.contextTypes = {
	intl: intlShape
}

const mapStateToProps = (state, ownProps) => ({
	id: ownProps.params.id,
	titleContainer: selectors.getFocusTitle(state),
	imageContainer: selectors.getFocusImage(state),
	content: selectors.getFocusContent(state),
	isCurrentTrack: playerSelectors.isCurrentTrack(state),
	isPlaying: playerSelectors.isPlaying(state)
})

const actions = {
	getFocus: getFocusAction,
	clearPlayqueue: clearPlayqueueAction
}

export default connect(mapStateToProps, actions)(FocusPage)



// WEBPACK FOOTER //
// ./src/pages/focus/FocusPage.jsx